'use client'

import React from 'react'
import { useState } from 'react'

import { useKeenSlider } from 'keen-slider/react'
import { KeenSliderFade, KeenSliderArrows } from '@/components/keen-slider/KeenSliderPlugins'
import 'keen-slider/keen-slider.min.css'

import { ImageFieldProps, LinkProps } from '@/types/types'

import ImageAndTextImage from './ImageAndTextImage'
import { MainColumn, MainColumnLeft, MainColumnRight } from '../main-column/MainColumn'

type ImageAndTextProps = {
  images: ImageFieldProps[]
  heading?: string
  title: string
  titleTag?: string
  titleClass?: string
  text?: string
  button?: LinkProps | null
}

// TODO: Bet you £50 they ask for left/right setting
export default function ImageAndText({
  images,
  heading,
  title,
  titleTag = 'h2',
  titleClass = 'h2',
  text,
  button,
}: ImageAndTextProps) {
  // Abort if images have been deleted from the media library
  if (!images) {
    return null
  }

  const [isMounted, setIsMounted] = useState(false)
  const [isDisabled, setIsDisabled] = useState(false)

  const [sliderRef, instanceRef] = useKeenSlider(
    {
      initial: 0,
      renderMode: 'custom',
      slides: {
        perView: 1,
        spacing: 0,
      },
      breakpoints: {
        '(min-width: 770px)': {
          disabled: true,
        },
      },
      created(s) {
        setIsDisabled(s.options.disabled)
        setIsMounted(true)
      },
      detailsChanged(s) {
        setIsDisabled(s.options.disabled)
      },
    },
    [KeenSliderFade],
  )

  let gridClass = `ms-up:grid ms-up:grid-cols-2 ms-up:items-start ms-up:gap-xs m-up:gap-m w-full flex-shrink-0 w-full`

  gridClass += images.length > 1 ? ' ms-up:aspect-[1254/716]' : ''
  // gridClass += images.length > 1 ? ' ms-up:aspect-[1250/680]' : ''

  return (
    <div className="component component--image-and-text">
      <MainColumn>
        <MainColumnLeft
          heading={heading}
          title={title}
          titleTag={titleTag}
          titleClass={titleClass}
          text={text}
          button={button}
          // TODO: change this/make customisable because images too big
          widthClass={images.length === 1 ? 'ms-up:w-2/5 m-up:w-1/2' : null}
        />

        <MainColumnRight>
          <div
            ref={sliderRef}
            className={`keen-slider keen-slider--fade ${gridClass}`}
            {...(!isMounted && { 'data-loading': true })}>
            {images.map((image, index) => {
              // TODO: If single image, add setting to display native size (for infographics etc)
              // TODO: Add field to component for caption?
              return (
                <ImageAndTextImage key={index} image={image} total={images.length} index={index} />
              )
            })}
          </div>

          <KeenSliderArrows sliderInstance={instanceRef} disabled={isDisabled} />
        </MainColumnRight>
      </MainColumn>
    </div>
  )
}
